import React from 'react';
import { motion } from 'framer-motion';

const events = [
  {
    id: 1,
    name: 'Annual Sports Meet 2025',
    image: '/assets/images/event-cards/event6.JPG',
  },
  {
    id: 2,
    name: "Cultural Day",
    image: '/assets/images/event-cards/event4.jpg',
  },
  {
    id: 3,
    name: 'Literary Day',
    image: '/assets/images/event-cards/event3.jpeg',
  },
  {
    id: 4,
    name: 'Athletics Meet 2024',
    image: '/assets/images/event-cards/event1.jpg',
  },
  // Add more events as needed
];

const RecentEvents = () => {
  return (
    <div className='text-center my-12 px-4'>

        <div className="font-bold text-theme text-3xl mb-7" style={{textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)"}}>Recent Events</div>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {events.map((event) => (
                   <motion.article
                   initial={{ y: 50, opacity: 0 }}
                   whileInView={{ y: 0, opacity: 1 }}
                   transition={{ ease: 'easeOut' }}
                   viewport={{ once: false }}
                   className={` relative pb-4 mb-4`}>
   
          <div
          key={event.id}
          className="m-auto max-w-sm rounded overflow-hidden"
          style={{
            boxShadow:"0px 0px 20px 0px #c7c7c7"
          }}
          >
          <img
            className="aspect-[21/9] h-48 object-cover"
            src={event.image}
            alt={event.name}
            />
          <div className="px-6 py-4">
            <div className="text-xl mb-2">{event.name}</div>
          </div>
        </div>
        </motion.article>
      ))}
    </div>
      </div>
  );
};

export default RecentEvents;
